const AlertSetUpTargetListItem = ({ notiTarget, notificationTargets, handleToggleNotificationTarget }) => {
  return (
    <tr key={notiTarget.NotificationTargetSysId}>
      <td><input type="checkbox" checked={notificationTargets.includes(notiTarget.NotificationTargetSysId)} onChange={() => handleToggleNotificationTarget(notiTarget.NotificationTargetSysId)} /></td>
      <td>{notiTarget.TargetType}</td>
      <td>{notiTarget.TargetValue}</td>
    </tr>
  )
}

export default AlertSetUpTargetListItem